import { type } from "arktype";

export const NewPasswordSchema = type({
  password: "string >= 8",
  confirmPassword: "string >= 8",
});

// for magic link flows - allows undefined when password not used
export const NewPasswordSchemaOptional = type({
  password: "string >= 8 | undefined",
  confirmPassword: "string >= 8 | undefined",
});

interface PasswordConfirmData {
  password?: string;
  confirmPassword?: string;
}

interface PasswordConfirmationNarrowOptions {
  skipWhenNoPassword?: boolean;
}

export function passwordConfirmationNarrow(
  options: PasswordConfirmationNarrowOptions = { skipWhenNoPassword: false },
) {
  return (
    data: PasswordConfirmData,
    ctx: { reject: (opts: object) => false },
  ): boolean => {
    if (options.skipWhenNoPassword && !data.password) return true;
    if (data.password === data.confirmPassword) return true;
    return ctx.reject({
      expected: "identical to password",
      actual: "",
      path: ["confirmPassword"],
    });
  };
}
